// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};


 //  InstantSearchResultItemCollection.prototype.compileTemplate = function() {
	// 	if (!this.isShow) {
	// 		return '';
	// 	}
 //        let url = '/collections/' + this.data.handle

 //        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
 //    	if (hasShopifyRoutes) {
 //    		url = Shopify.routes.root.replace(/\/$/, '') + url;
 //    	}
    
	// 	this.searchTerm = Utils.stripHtml(Globals.currentTerm);
	// 	// var searchLink = Utils.reBuildUrlBaseOnLocale('/collections/' + this.data.handle);
	// 	var searchLink = url;
	// 	var highlightedSuggestionResult = this._highlightSuggestionResult(this.data.title, this.searchTerm);
	// 	return this.getTemplate()
	// 		.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
	// 		.replace(/{{escapedDataTitle}}/g, Utils.stripHtml(this.data.title))
	// 		.replace(/{{escapedDataId}}/g, Utils.stripHtml(this.data.id))
	// 		.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
	// 		.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
	// 		.replace(/{{searchLink}}/g, searchLink)
	// 		.replace(/{{highlightedSuggestionResult}}/g, highlightedSuggestionResult);
	// }
  
})();
